export default __webpack_public_path__ + "static/media/11.67c299f8.png";